/**
 * Created by tofael on 7/17/17.
 */
import React from 'react';
import Toggle from 'material-ui/Toggle';
import RaisedButton from 'material-ui/RaisedButton';
import {green800,red700, white} from 'material-ui/styles/colors';

const style = {
  approveBtn: {
    marginBottom: 12,
    marginTop: 12
  },
  toggle: {
    marginBottom: 16,
  },
  box: {
    backgroundColor: '#fff',
    borderRadius: '1%',
    overflow: 'hidden',
    position: 'relative',
    marginBottom: '24px',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)',
    padding: '10px'
  }
};

const Actions = ({locked, receiveFeedbackEmail, toggleRoleDialog, onToggle, showAlert}) => (
      <div style={style.box}>
        <Toggle
          style={style.toggle}
          onToggle={onToggle}
          toggled={receiveFeedbackEmail}
          label="Receive Feedback Email"
        />
        {!locked && <RaisedButton onTouchTap={showAlert.bind(null,'Are you sure you want to lock the user ?','lock')} fullWidth={true} primary={true} label="Lock User"/> }
        {locked && <RaisedButton onTouchTap={showAlert.bind(null,'Are you sure you want to unlock the user ?','unlock')} fullWidth={true} primary={true} label="Unlock User"/> }
        <br />
        <br />
        <RaisedButton onTouchTap={showAlert.bind(null,'Are you sure you want to reset password for the user ?','reset-password')} labelColor={white} fullWidth={true} backgroundColor={red700} label="Reset Password"/>
        <br />
        <br />
        <RaisedButton onTouchTap={toggleRoleDialog} labelColor={white} fullWidth={true} backgroundColor={green800} label="Update User Role"/>
      </div>
);

export default Actions;


// WEBPACK FOOTER //
// ./src/screens/profile/admin/admin-actions.js